function getPassword(size = 8, alphanumeric, type = 'all') {
	const chars = alphanumeric
		? type === 'all'
			? 'abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ012346789'
			: type === 'number'
			? '012346789'
			: 'abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ'
		: 'abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ012346789.@$#';
	let password = '';
	for (var i = 0; i < size; i++) {
		password += chars.charAt(Math.floor(Math.random() * chars.length));
	}
	return password;
}

export default getPassword;
